// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__38Fvo","name":"Header_name__2ozd_","birthday":"Header_birthday__2hGeb","skeleton":"Header_skeleton__3zt00"};